export default "__VITE_PUBLIC_ASSET__163707cd__"